import { prefersReducedMotion } from "../../../common/scroll";

export const EVENT_TABS_ANCHOR_ID = "event-tabs";

export const scrollToEventTabs = () => {
  // Next frame: the router re-renders the tab first, and the scroll must land after that.
  requestAnimationFrame(() =>
    // jsdom leaves scrollIntoView undefined on Element.
    document.getElementById(EVENT_TABS_ANCHOR_ID)?.scrollIntoView?.({
      behavior: prefersReducedMotion() ? "auto" : "smooth",
      block: "start",
    }),
  );
};
